import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

export const AuditRoutes = [
  {
    path: '/common/audits',
    name: 'Audit Log',
    meta: {
      title: 'Audit Log',
    },
    component: () => import('../views/common/AuditLog.vue'),
  },
];

AuditRoutes.forEach((element, index) => {
  AuditRoutes[index].beforeEnter = async (to, from, next) => {
    // AuditUser (viewer) and AuditLogAdministration (admin) are separate roles; both may open this screen.
    await accessCriteria([...authRoles.AuditUsers, ...authRoles.AuditLogAdmins], next);
  };
});

export default AuditRoutes;
